"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Provider } from "react-redux";
import { getStore } from "#/store/makeStore";
const store = getStore();
export const ReduxProvider: React.FC<React.PropsWithChildren> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Provider store={store}>{children}</Provider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};